import { Box, Grid, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { DeviceProfile } from "@/__generated__/graphql";
import { ContactsSumaryCard } from "./ContactsSummaryCard";
import { ConfiguredMetricCard } from "./ConfiguredMetricCard";
import { ConfigurationsPanel } from "./ConfigurationsPanel";

export interface UserNotificationPreference {
  userId: string;
  useWhatsapp: boolean;
  useSms: boolean;
  useAmaruLite: boolean;
  useEmail: boolean;
}

interface SummaryStepProps  {
  userPreferences: {
    current: Map<string, UserNotificationPreference>
  }
  deviceProfile?: Partial<DeviceProfile>
}

interface ChannelStats {
  email: number;
  whatsapp: number;
  sms: number;
  push: number;
}

const  SummaryStep = ({
  userPreferences,
  deviceProfile
}: SummaryStepProps) => {
  const { getValues, watch } = useFormContext();
  const values = getValues();

  const selectedMetric = watch('metric');

  
  const currentPrefsArray = Array.from(userPreferences.current.values());
  const channelStats: ChannelStats = {
    email: currentPrefsArray.filter(pref => pref.useEmail).length,
    whatsapp: currentPrefsArray.filter(pref => pref.useWhatsapp).length,
    sms: currentPrefsArray.filter(pref => pref.useSms).length,
    push: currentPrefsArray.filter(pref => pref.useAmaruLite).length,
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: 1, height: 1 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5">Resumen de la creación/edición de alerta:</Typography>
      </Box>


      {/* Content Grid */}
      <Box sx={{ display: 'flex', width: 1, height: '60vh' }}>
        <Grid container>
          <Grid item xs={6}>
            <ConfiguredMetricCard
              metric={selectedMetric}
              deviceProfile={deviceProfile}
            />
          </Grid>
          <Grid container item spacing={1} xs={12}>

            {/* Destinatarios */}
            <Grid item xs={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: 1,
              }}
            >
              <ContactsSumaryCard channelStats={channelStats}/>
            </Grid>

            {/* Configuraciones */}
            <Grid item xs={6}
              sx={{
                justifyContent: 'flex-start',
                display: 'flex',
                flexDirection: 'column',
                height: 1,
              }}
            >
              <ConfigurationsPanel
                configurations={values.configurations}
                unit={values.unit}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default SummaryStep;